export const PHOTO_DAYS = new Set([
  1, 2, 3, 5, 9, 10, 12, 19, 20, 24, 58, 60, 96, 97, 98, 99, 100, 101,
  102, 103, 104, 105, 106, 107, 108, 109, 111, 112, 113, 114, 115, 116, 117,
  118, 119, 120, 121,
]);

export function hasPhotoForDay(day) {
  return PHOTO_DAYS.has(day);
}

export function hasTextForDay(day) {
  return day >= 1 && day <= 95;
}
